export default __webpack_public_path__ + "static/media/slide9.e00e96b2.png";